import React, { useEffect, useState } from "react";
import { useForm } from "../../../hooks/useForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getLogin, updateProfileAsync } from "../../../features/userSlice";
import ReactDatePicker from "react-datepicker";
import { callingCode, Nationality } from "../../../helpers/helper";
import MainModal from "../../modals/MainModal";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const login = useSelector(getLogin);
  const dispatch = useDispatch();
  const EmailUpdated = useSelector((state) => state.user.resetEmailStatus);

  const [show, setShow] = useState(false);
  const [modal, setModal] = useState("resetEmail");

  // const selectRef = React.useRef(null);
  // const nationalityRef = React.useRef(null);
  // const countryCodeRef = React.useRef(null);

  const userDatass = JSON.parse(sessionStorage.getItem("userData")) || [];
  // const userData = useSelector((state) => state.user.userData, shallowEqual);

  const { Authorization } = userDatass || {};

  const navigate = useNavigate();

  // React.useEffect(() => {
  //   if (userData.length === 0) {
  //     navigate("/");
  //   }
  // }, [userData]);

  // useEffect(() => {}, [EmailUpdated]);

  const {
    state,
    setState,
    isSubmit,
    formErrors,
    handleInputChange,
    handleFormSubmit,
    checkErrors,
    setIsSubmit,
  } = useForm({
    val: {
      FirstName: "",
      LastName: "",
      Dob: "",
      Gender: "",
      Email: "",
      MobileNo: "",
      Nationality: "",
      CountryCode: "",
    },
    // inValidate: customValidate,
  });

  const [startDate, setStartDate] = useState(
    new Date().setFullYear(new Date().getFullYear() - 50)
  );
  const [endDate, setEndDate] = useState(
    new Date().setFullYear(new Date().getFullYear() - 5)
  );

  const handleDatePicker = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    setState({ ...state, Dob: myDate });
    delete formErrors["Dob"];
  };

  // React.useEffect(() => {
  //   if (Object?.keys(userData)?.length > 0) {
  //     setState({
  //       FirstName: userData.firstName,
  //       LastName: userData.lastName,
  //       Dob: userData.dob,
  //       Gender: userData.gender,
  //       Email: userData.email,
  //       MobileNo: userData.mobile,
  //       Nationality: userData.nationality,
  //       CountryCode: userData.countryCode,
  //     });
  //     // selectRef.current.value = userData.gender;
  //     // nationalityRef.current.value = userData.nationality;
  //     // countryCodeRef.current.value = userData.countryCode;
  //   }
  // }, [userData]);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userData")) || [];
    if (Object?.keys(userData)?.length > 0) {
      setState({
        FirstName: userData.firstName,
        LastName: userData.lastName,
        Dob: userData.dob,
        Gender: userData.gender,
        Email: userData.email,
        MobileNo: userData.mobile,
        Nationality: userData.nationality,
        CountryCode: userData.countryCode,
      });
      // selectRef.current.value = userData.gender;
      // nationalityRef.current.value = userData.nationality;
      // countryCodeRef.current.value = userData.countryCode;
    }
  }, []);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      dispatch(updateProfileAsync({ state, Authorization }));
    }
  }, [formErrors, isSubmit]);

  return (
    <>
      <section className="my-profile">
        <div className="container">
          <form action="">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">First name</label>
                  <input
                    type="text"
                    placeholder="Enter First name"
                    autoComplete="off"
                    name="FirstName"
                    value={state.FirstName}
                    onChange={handleInputChange}
                    onBlur={(e) => checkErrors(e)}
                  />
                  <p className="text-danger">{formErrors?.FirstName}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">Last name</label>
                  <input
                    type="text"
                    placeholder="Enter Last name"
                    autoComplete="off"
                    name="LastName"
                    value={state.LastName}
                    onChange={handleInputChange}
                    onBlur={(e) => checkErrors(e)}
                  />
                  <p className="text-danger">{formErrors?.LastName}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">Email</label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    autoComplete="off"
                    name="Email"
                    value={state.Email}
                    disabled
                    onChange={handleInputChange}
                    onBlur={(e) => checkErrors(e)}
                  />
                  <p className="text-danger">{formErrors?.Email}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group position-relative">
                  <div className="select-arrow"></div>
                  <label htmlFor="">Gender</label>
                  <select
                    name="Gender"
                    onChange={handleInputChange}
                    onBlur={(e) => checkErrors(e)}
                    value={state.Gender}
                    className="form-select"
                  >
                    <option value="">Select Gender</option>
                    {["Male", "Female", "Others"].map((ele, ind) => (
                      <option value={ele} key={ind} defaultValue={state.Gender}>
                        {ele}
                      </option>
                    ))}
                  </select>
                  <p className="text-danger">{formErrors?.Gender}</p>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <label htmlFor="">Date of birth</label>
                  <ReactDatePicker
                    onChange={handleDatePicker}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    // selected={new Date(state.Dob)} ////Problem
                    selected={Date.parse(state.Dob)}
                    minDate={startDate}
                    maxDate={endDate}
                    dateFormat="YYYY-MM-DD"
                    name="Dob"
                    placeholderText="YYYY-MM-DD"
                    value={state.Dob}
                    onBlur={(e) => checkErrors(e)}
                    className={`form-control ${
                      formErrors.Dob && "form-control-danger"
                    }`}
                    style={{ Zindex: "100" }}
                  />
                  <p className="text-danger">{formErrors?.Dob}</p>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-6 col-md-6">
                <div className="form-group position-relative">
                  <div className="select-arrow"></div>
                  <label htmlFor="">Nationality</label>
                  <select
                    name="Nationality"
                    onChange={handleInputChange}
                    onBlur={(e) => checkErrors(e)}
                    // defaultValue={state.Nationality}
                    value={state.Nationality}
                    className="form-select"
                  >
                    <option value="">Select Nationality</option>
                    {Nationality.map((ele, ind) => (
                      <option
                        key={ind}
                        value={ele.value}
                        defaultValue={state.Nationality}
                      >
                        {ele.label}
                      </option>
                    ))}
                  </select>
                  <p className="text-danger">{formErrors?.Nationality}</p>
                </div>
              </div>
              {/*  */}

              <div className="col-lg-6">
                <div className="mobile-number">
                  <div className="form-group">
                    <label for="">Mobile Number </label>
                    <div>
                      <div className="position-relative select-country-code">
                        <div className="select-arrow"></div>
                        <select
                          name="CountryCode"
                          onChange={handleInputChange}
                          onBlur={(e) => checkErrors(e)}
                          value={state.CountryCode}
                          className="form-select"
                        >
                          <option value="">Select Country code</option>
                          {callingCode.map((ele, ind) => (
                            <option
                              key={ind}
                              value={ele.value}
                              defaultValue={state.CountryCode}
                            >
                              {ele.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <input
                        type="text"
                        placeholder="Enter Mobile Number"
                        autoComplete="off"
                        name="MobileNo"
                        value={state.MobileNo}
                        onChange={handleInputChange}
                        onBlur={(e) => checkErrors(e)}
                      />
                    </div>
                  </div>
                  <p className="text-danger">{formErrors?.CountryCode}</p>
                  <p className="text-danger">{formErrors?.MobileNo}</p>
                </div>
              </div>

              <div className="col-lg-12 text-end">
                <div className="text-end d-inline-block">
                  <span
                    className="semi-blue-12 change-pass pointer"
                    onClick={() => {
                      setShow(true);
                      setModal("resetEmail");
                    }}
                  >
                    Change Email?
                  </span>
                  <span
                    className="semi-blue-12 change-pass pointer"
                    onClick={() => {
                      setShow(true);
                      setModal("resetPassword");
                    }}
                  >
                    Change Password?
                  </span>
                </div>
              </div>

              <div className="col-lg-12 ">
                <div className="text-center">
                  <button
                    onClick={handleFormSubmit}
                    className="cmn-btn save-btn"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      {show ? (
        <MainModal
          modal={modal}
          setShow={setShow}
          show={show}
          setModal={setModal}
          // extraData={setIsClicked}
        />
      ) : null}
    </>
  );
};

export default Profile;
